import SpoilerEditorWrapper from "./Components/Wrappers/SpoilerEditorWrapper.js";
import { DEFAULTS } from "./defaults.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { SPOILER_TYPE } from "./types.js";
import { getTextButtons } from "./getTextButtons.js";
import { spoilerConverter } from "./spoiler-converter.js";
const pluginSpoiler = (config) => {
  const pluginConfig = { ...DEFAULTS.config, SpoilerEditorWrapper, ...config };
  return {
    config: pluginConfig,
    pmNodeConverters: [],
    pmMarkConverters: [spoilerConverter],
    type: SPOILER_TYPE,
    tiptapExtensions,
    textButtons: getTextButtons()
  };
};
export {
  SpoilerEditorWrapper,
  pluginSpoiler
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
